export default "__VITE_ASSET__r30iBY8n__"